import { type RefObject } from 'react';

import type { ExtractedSidebarSlot } from './slots.js';
import { useBreakpointCollapse } from '../shared/useBreakpointCollapse.js';

type RenderedLayout = 'split' | 'collapsed' | 'drawer';

export function useLayoutState({
  sidebar,
  containerRef,
}: {
  sidebar: ExtractedSidebarSlot;
  containerRef: RefObject<HTMLDivElement | null>;
}) {
  const { containerWidth, collapsed, setCollapsed, isBelowBreakpoint } =
    useBreakpointCollapse({
      collapsed: {
        value: sidebar.config.collapsed,
        defaultValue: sidebar.config.defaultCollapsed ?? false,
        onChange: sidebar.config.onCollapsedChange,
      },
      breakpoint: sidebar.config.breakpoint,
      containerRef,
      onBreakpointTransition: sidebar.config.onBreakpointTransition,
      autoCollapse: true,
    });

  let mode: RenderedLayout = 'split';
  if (collapsed) {
    mode = 'collapsed';
  }
  if (isBelowBreakpoint) {
    mode = 'drawer';
  }

  return {
    collapsed,
    containerWidth,
    isBelowBreakpoint,
    mode,
    setCollapsed,
  };
}
